const trimValue = (value) => String(value ?? "").trim();

export const SIGNUP_DOB_PATTERN = /^\d{6}-\d$/;
export const SIGNUP_DOB_FORMAT_MESSAGE =
  "생년월일은 930801-1 형식으로 입력해주세요.";

export const formatSignupDobInput = (value) => {
  const rawDigits = trimValue(value).replace(/\D/g, "");
  if (/^(19|20)\d{6}/.test(rawDigits)) {
    const legacyDob = rawDigits.slice(2, 8);
    const backDigit = rawDigits.slice(8, 9);
    return backDigit ? `${legacyDob}-${backDigit}` : legacyDob;
  }

  const digits = rawDigits.slice(0, 7);
  return digits.length > 6
    ? `${digits.slice(0, 6)}-${digits.slice(6)}`
    : digits;
};
